import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Rights } from '../../models/server/enums/rights';
import { NotificationService } from '../../services/actions/notification.service';
import { ConnectedUsersStateService } from '../../services/state/connected-users-state.service';
import { RouteData } from '../route-data';

@Injectable({
    providedIn: 'root',
})
export class UserGrantedGuard {
    /**
     * Constructeur.
     * @param router : Instance du router.
     */
    constructor(
        private router: Router,
        public connectedUserStateService: ConnectedUsersStateService,
        private notificationService: NotificationService
    ) {}

    /**
     * Listes des rôles permettant d'acceder à la route.
     */
    expectedRights: Rights[] = [];

    /**
     * Indique si la route peut-être activée.
     * @param next : Instance de la route.
     * @param state : Etat du routeur.
     */
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // this will be passed from the route config
        // on the data property
        this.expectedRights = (next.data as RouteData).expectedRights as Rights[];

        var connectedUser = this.connectedUserStateService.getUserConnected();

        if (connectedUser) {
            if (this.expectedRights.filter((expectedRight) => connectedUser.rights.findIndex((userRight) => userRight === expectedRight) !== -1).length === 0) {
                this.notificationService.displayError(
                    'Absence de droits',
                    "L'utilisateur n'est pas autorisé à exécuter cette action. Veuillez contacter votre administrateur pour qu'il vous accorde les droits nécessaires"
                );
                console.log("L'utilisateur n'est pas authorisé");
                this.router.navigate(['login']);
                return false;
            }

            return true;
        } else {
            console.log("L'utilisateur n'est pas authentifié.");
            return false;
        }
    }
}
